import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { sortOpts } from '../../../utils/utils';

class FilterForm extends React.Component {

  componentWillMount(){
    const { options, setFilters, filter } = this.props;
    const values = {};
    const storedString = localStorage.paymentsFilter;
    const storedFilter = (storedString && JSON.parse(storedString)) ||
      {
        payer: ['Артель'],
        order: ['Издержки'],
        payed: ['Не оплачен']
      };

    for(let filterName in storedFilter){
      if(
        storedFilter.hasOwnProperty(filterName) &&
        storedFilter[filterName].length
      ){
        if(options.hasOwnProperty(filterName)){
          values[filterName] = [];
          for(let i = 0; i < storedFilter[filterName].length; i++){
            if(options[filterName].hasOwnProperty(storedFilter[filterName][i])){
              values[filterName].push(storedFilter[filterName][i]);
            }
          }
        }
        else{
          values[filterName] = storedFilter[filterName];
        }
      }
    }
    setFilters({
      ...filter,
      ...values
    });
  }

  setFilter = (filter, e) => {
    const valsArray = e.map(val => val.label);
    this.props.setFilters({
      ...this.props.filter,
      [filter]: valsArray
    });
  }

  setDateTo = (e) => {
    this.props.setFilters({
      ...this.props.filter,
      dateTo: e.format('Y-MM-DD')
    });
  }

  setDateFrom = (e) => {
    this.props.setFilters({
      ...this.props.filter,
      dateFrom: e.format('Y-MM-DD')
    });
  }

  selectOpenOrders = () => {
    const { order } = this.props.options;
    const { orders } = this.props;
    const filter = [];
    for (let i = 0; i < orders.length; i++) {
      if (
        Math.abs(orders[i].p1_balance).toFixed(2) !== '0.00' ||
        Math.abs(orders[i].p2_balance).toFixed(2) !== '0.00'
      ) {
        for (let key in order){
          if(
            order.hasOwnProperty(key) &&
            key.split(" ")[0] === ""+orders[i].order_num
          ) {
            filter.push(key);
            break;
          }
        }
      }
    }
    this.props.setFilters({
      ...this.props.filter,
      order: filter
    });
  }

  render() {
    const { options, filter } = this.props;

    const sellerOpts = [];
    for (let key in options.seller){
      if(options.seller.hasOwnProperty(key)) {
        sellerOpts.push({label: key});
      }
    }
    sellerOpts.sort(sortOpts);

    const accountOpts = [];
    for (let key in options.account){
      if(options.account.hasOwnProperty(key)) {
        accountOpts.push({label: key});
      }
    }
    accountOpts.sort(sortOpts);

    const projectOpts = [];
    for (let key in options.project){
      if(options.project.hasOwnProperty(key)) {
        projectOpts.push({label: key});
      }
    }
    projectOpts.sort(sortOpts);

    const payerOpts = [];
    for (let key in options.payer){
      if(options.payer.hasOwnProperty(key)) {
        payerOpts.push({label: key});
      }
    }
    payerOpts.sort(sortOpts);

    const srvcOpts = [];
    for (let key in options.srvc){
      if(options.srvc.hasOwnProperty(key)) {
        srvcOpts.push({label: key});
      }
    }
    srvcOpts.sort(sortOpts);

    const orderOpts = [];
    for (let key in options.order){
      if(options.order.hasOwnProperty(key)) {
        orderOpts.push({label: key});
      }
    }
    // orderOpts.sort(sortOpts);

    const monthOpts = [];
    for (let key in options.month){
      if(options.month.hasOwnProperty(key)) {
        monthOpts.push({label: key});
      }
    }
    // monthOpts.sort(sortOpts);

    const quarterOpts = [];
    for (let key in options.quarter){
      if(options.quarter.hasOwnProperty(key)) {
        quarterOpts.push({label: key});
      }
    }
    quarterOpts.sort(sortOpts);

    const yearOpts = [];
    for (let key in options.year){
      if(options.year.hasOwnProperty(key)) {
        yearOpts.push({label: key});
      }
    }
    yearOpts.sort(sortOpts);

    const payedOpts = [];
    for (let key in options.payed){
      if(options.payed.hasOwnProperty(key)) {
        payedOpts.push({label: key});
      }
    }
    payedOpts.sort(sortOpts);

    return (
      <div>
        <div className="visible-print">
          {filter.dateFrom && <div>Начало периода {filter.dateFrom}</div>}
          {filter.dateTo && <div>Конец периода {filter.dateTo}</div>}
          {filter.year.length>0 && <div>Год {filter.year.join()}</div>}
          {filter.quarter.length>0 && <div>Квартал {filter.quarter.join()}</div>}
          {filter.month.length>0 && <div>Месяц {filter.month.join()}</div>}
          {filter.seller.length>0 && <div>Поставщик {filter.seller.join()}</div>}
          {filter.payer.length>0 && <div>Плательщик {filter.payer.join()}</div>}
          {filter.srvc.length>0 && <div>Метод {filter.srvc.join()}</div>}
          {filter.payed.length>0 && <div>Оплачен {filter.payed.join()}</div>}
          {filter.order.length>0 && <div>Заказ {filter.order.join()}</div>}
          {filter.account.length>0 && <div>Аккаунт {filter.account.join()}</div>}
          {filter.project.length>0 && <div>Проджект {filter.project.join()}</div>}
        </div>
        <div className="form-inline hidden-print">
          <div style={{display:'inline-block', verticalAlign: 'middle'}}>
            Начало периода
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(filter.dateFrom)}
              selectsStart
              startDate={moment(filter.dateFrom)}
              endDate={moment(filter.dateTo)}
              onChange={this.setDateFrom}
            />
          </div>{" - "}
          <div style={{display:'inline-block', verticalAlign: 'middle'}}>
            Конец периода
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(filter.dateTo)}
              selectsStart
              startDate={moment(filter.dateFrom)}
              endDate={moment(filter.dateTo)}
              onChange={this.setDateTo}
            />
          </div>{" "}
          <div className="input-group">
            Год
            <Select
              style={{width:'230px'}}
              options={yearOpts}
              multi
              valueKey="label"
              value={filter.year}
              onChange={(e) => this.setFilter('year', e)}
              placeholder="Год"
            />
          </div>{" "}
          <div className="input-group">
            Квартал
            <Select
              style={{width:'230px'}}
              options={quarterOpts}
              multi
              valueKey="label"
              value={filter.quarter}
              onChange={(e) => this.setFilter('quarter', e)}
              placeholder="Квартал"
            />
          </div>{" "}
          <div className="input-group">
            Месяц
            <Select
              style={{width:'230px'}}
              options={monthOpts}
              multi
              valueKey="label"
              value={filter.month}
              onChange={(e) => this.setFilter('month', e)}
              placeholder="Месяц"
            />
          </div>{" "}
          <div className="input-group">
            Поставщик
            <Select
              style={{width:'230px'}}
              options={sellerOpts}
              multi
              valueKey="label"
              value={filter.seller}
              onChange={(e) => this.setFilter('seller', e)}
              placeholder="Поставщик"
            />
          </div>{" "}
          <div className="input-group">
            Плательщик
            <Select
              style={{width:'230px'}}
              options={payerOpts}
              multi
              valueKey="label"
              value={filter.payer}
              onChange={(e) => this.setFilter('payer', e)}
              placeholder="Плательщик"
            />
          </div>{" "}
          <div className="input-group">
            Метод оплаты
            <Select
              style={{width:'230px'}}
              options={srvcOpts}
              multi
              valueKey="label"
              value={filter.srvc}
              onChange={(e) => this.setFilter('srvc', e)}
              placeholder="Метод оплаты"
            />
          </div>{" "}
          <div className="input-group">
            Оплачен
            <Select
              style={{width:'230px'}}
              options={payedOpts}
              multi
              valueKey="label"
              value={filter.payed}
              onChange={(e) => this.setFilter('payed', e)}
              placeholder="Оплачен"
            />
          </div>{" "}
          <div className="input-group">
            Заказ
            <Select
              style={{width:'230px'}}
              options={orderOpts}
              multi
              valueKey="label"
              value={filter.order}
              onChange={(e) => this.setFilter('order', e)}
              placeholder="Заказ"
            />
              <button
                className="btn btn-md btn-info"
                onClick={this.selectOpenOrders}
              >
                Выбрать не закрытые заказы
              </button>
          </div>{" "}
          <div className="input-group">
            Аккаунт
            <Select
              style={{width:'230px'}}
              options={accountOpts}
              multi
              valueKey="label"
              value={filter.account}
              onChange={(e) => this.setFilter('account', e)}
              placeholder="Аккаунт"
            />
          </div>{" "}
          <div className="input-group">
            Проджект
            <Select
              style={{width:'230px'}}
              options={projectOpts}
              multi
              valueKey="label"
              value={filter.project}
              onChange={(e) => this.setFilter('project', e)}
              placeholder="Проджект"
            />
          </div>
        </div>
      </div>
    );
  }

}

FilterForm.propTypes = {
  options: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired
}

export default FilterForm;



// WEBPACK FOOTER //
// ./src/components/reports/payments/FilterForm.js